module.exports = __webpack_public_path__ + "static/media/CT_2019_30446_1005_pdf.f6964514.pdf";